import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { selectSolarFilter } from "../../../../../redux/features/solar-filter/solar-filter-slice";
import { EDateTypes } from "../../../../../shared/oversight-core/enums/date-types";
import { EUnitType } from "../../../../../shared/oversight-core/enums/unit-type";
import FilteringSidePanel from "../../../../../shared/oversight-core/shared-components/filtering-side-panel/filtering-side-panel";
import AppDatePicker from "../../../../../shared/oversight-core/ui-elements/app-date-picker/app-date-picker";
import AppDateRangeSelector from "../../../../../shared/oversight-core/ui-elements/app-date-range-selector/app-date-range-selector";

interface IProps {
  show: boolean;
  onClose: () => void;
  onFilter: (selectedDate: Date, selectedDateType: EDateTypes) => void;
  onClearAll: () => void;
  selectedUnitType: EUnitType;
}

const GoodWeSiteDashboardFilters = (props: IProps) => {
  const solarFilterStore = useSelector(selectSolarFilter);

  const { show, onClose, onFilter, onClearAll, selectedUnitType } = props;

  const [selectedDateType, setSelectedDateType] = useState<EDateTypes>(
    EDateTypes.DAILY,
  );
  const [selectedDate, setSelectedDate] = useState(
    new Date(solarFilterStore.selectedDate),
  );

  useEffect(() => {
    setSelectedDateType(solarFilterStore.selectedDateType);
  }, [solarFilterStore]);

  return (
    <FilteringSidePanel
      isOpen={show}
      onClose={onClose}
      onFilter={() => {
        onFilter(selectedDate, selectedDateType);
      }}
      onClearAll={onClearAll}
    >
      <>
        <div className="mt-4">
          {selectedUnitType === EUnitType.ENERGY ? (
            <AppDateRangeSelector
              startDate={selectedDate}
              endDate={new Date()}
              setSelectedDate={(date: Date) => {
                setSelectedDate(date);
              }}
              dateTypes={[
                [EDateTypes.DAILY, EDateTypes.MONTHLY, EDateTypes.YEARLY],
              ]}
              selectedDateType={selectedDateType}
              setSelectedDateType={setSelectedDateType}
              maxDate={
                selectedDateType === EDateTypes.DAILY
                  ? new Date()
                  : new Date(
                      new Date().getFullYear(),
                      new Date().getMonth() + 1,
                      0,
                    )
              }
              showDatePicker={false}
            />
          ) : (
            <AppDatePicker
              label="Date"
              selectedDate={selectedDate}
              onChange={(date) => setSelectedDate(date)}
              dateFormat="dd-MMM-yyyy"
              maxDate={new Date()}
            />
          )}
        </div>
      </>
    </FilteringSidePanel>
  );
};

export default GoodWeSiteDashboardFilters;
